import { isequal } from 'core/libs/lodash';

export default function valueEmitterFactory(initialValue) {
  let listeners = [];
  let value = initialValue;

  return {
    get() {
      return value;
    },

    set(newValue) {
      if (!isequal(value, newValue)) {
        value = newValue;
        listeners = listeners.filter(({ handler }) => {
          if (handler) handler(value);
          return !!handler;
        });
      }
    },

    subscribe(handler) {
      const envelope = { handler };
      listeners.push(envelope);
      return () => delete envelope.handler;
    },
  };
}
